/* This file checks if any steps needs to be revised before you can download your will. 
   If we remove functionality from the system that affects the details in the will, testators
   need to go back to that step and update the data to follow the new implementation.
   With this we can check if any legacy values have been selected for testators and mark
   the corrolating step to be revised. 
 */

export default {
  anyStepsToRevise(testator) {
    let revises = [];
    for (let i = 1; i < 8; i++) {
      revises.push(this.reviseStep(testator, i));
    }

    return revises.includes(true);
  },
  reviseStep(testator, step) {
    if (step === 2) {
      return this.step_2_internal_executor_updates_to_revise(testator);
    }
    if (step === 5) {
      // Updates introduced in this ticket: https://height.app/rXjSZtGSUQ/working-board-view-f6fcdf0285da46d1ae4473346bdea333/T-48
      if (testator.remainderOfEstate) {
        if (
          ["SPOUSE_AND_CHILDREN", "CHILDREN"].includes(
            testator.remainderOfEstate.distribution
          )
        ) {
          return true;
        }
        if (
          testator.remainderOfEstate.distribution === "SPECIFIC_PERCENTAGES"
        ) {
          let check = false;
          testator.remainderOfEstate.distributionSpecificPercentages
            .filter((d) => d.beneficiaryType == "Person")
            .forEach((dstr) => {
              if (
                dstr.distributionSpecificPercentageAlternativeBeneficiaries
                  .length === 0
              ) {
                check = true;
              }
            });
          return check;
        }
        if (
          ["UNBORN_CHILDREN", "SPECIFIC_PEOPLE"].includes(
            testator.remainderOfEstate.alternativeDistribution
          )
        ) {
          return true;
        }
      }
    }
    return false;
  },
  step_2_internal_executor_updates_to_revise(testator) {
    if(testator.bypassOmOnlyExecutor){
      return false;
    }

    // Updates introduced in this ticket: https://height.app/rXjSZtGSUQ/working-board-view-f6fcdf0285da46d1ae4473346bdea333/T-143
    if ((testator.enabledFeatures || []).includes("om_only_executor")) {
      if (
        testator.executorParty !== null &&
        (testator.executorParty !== "INTERNAL_COMPANY" ||
          testator.alternativeExecutorParty !== null)
      ) {
        return true;
      }

      const hasExecutor = testator.testatorRelationships.some(
        (relationship) => {
          if (
            relationship.relation === "CO_EXECUTOR" ||
            relationship.relation === "ALTERNATIVE_EXECUTOR" ||
            relationship.relation === "EXECUTOR"
          ) {
            return true;
          }
          return false;
        }
      );

      return hasExecutor;
    } else {
      return false;
    }
  },
};
